import { render, staticRenderFns } from "./archivedInQualityRequests.vue?vue&type=template&id=7b36734e&"
import script from "./archivedInQualityRequests.vue?vue&type=script&lang=js&"
export * from "./archivedInQualityRequests.vue?vue&type=script&lang=js&"
import style0 from "./archivedInQualityRequests.vue?vue&type=style&index=0&id=7b36734e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports